import { Activity, RotateCcw } from "lucide-react";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useIntegrations } from "../data/platform-data";
import { useTenantRuntime } from "../config/TenantRuntime";

const providerKey: Record<string, "eva" | "paglog" | "mobimedical" | "signature"> = {
  EVA: "eva",
  PAGLOG: "paglog",
  MOBIMEDICAL: "mobimedical",
  ASSINATURA: "signature",
  SIGNATURE: "signature",
};

export function IntegrationsPage() {
  const query = useIntegrations();
  const { tenant, hasModule } = useTenantRuntime();
  if (query.isLoading) return <Skeleton className="detail-skeleton" />;
  if (query.error) {
    return <EmptyState title="Falha ao carregar integrações" description={query.error.message} />;
  }

  const integrations = (query.data ?? []).filter((integration) => {
    const key = providerKey[integration.provider.toUpperCase()];
    return key ? tenant.integrations[key].enabled : true;
  });

  return (
    <div className="page-stack">
      <div className="integration-grid">
        {integrations.map((integration) => (
          <Card key={integration.provider}>
            <div className="integration-card">
              <div className="integration-icon">
                <Activity />
              </div>
              <div>
                <h2>{integration.provider}</h2>
                <p>Último evento: {integration.lastEvent}</p>
              </div>
              <Badge
                tone={
                  integration.status === "HEALTHY" || integration.status === "SAUDÁVEL"
                    ? "success"
                    : "warning"
                }
              >
                {integration.status}
              </Badge>
            </div>
            <div className="integration-meta">
              <span>Modo</span>
              <strong>{integration.mode}</strong>
            </div>
          </Card>
        ))}

        {hasModule("public_payment_portal") && (
          <Card>
            <div className="integration-card">
              <div className="integration-icon">
                <Activity />
              </div>
              <div>
                <h2>PORTAL DE SEGUNDA VIA</h2>
                <p>CPF/CNPJ, OTP e emissão Paglog</p>
              </div>
              <Badge tone="success">CONFIGURADO</Badge>
            </div>
            <div className="integration-meta">
              <span>Segurança</span>
              <strong>OTP OBRIGATÓRIO</strong>
            </div>
          </Card>
        )}
      </div>

      <Card title="Processamento assíncrono">
        <div className="health-row">
          <div>
            <span>Inbox aguardando</span>
            <strong>0</strong>
          </div>
          <div>
            <span>Outbox aguardando</span>
            <strong>0</strong>
          </div>
          <div>
            <span>Retentativas</span>
            <strong>0</strong>
          </div>
          <div>
            <span>Dead letter</span>
            <strong>0</strong>
          </div>
          <Button variant="secondary">
            <RotateCcw size={16} /> Reprocessar selecionados
          </Button>
        </div>
      </Card>
    </div>
  );
}
